export const MiddleLineLabel = ({
  viewBox,
  label,
  position = 'left',
  marginRight = 0,
}: {
  viewBox: any;
  label: string;
  position?: 'left' | 'right';
  marginRight?: number;
}) => {
  // Calculate bubble dimensions
  const textWidth = label.length * 6;
  const dynamicWidth = Math.max(40, textWidth + 16);
  const chartEndX = viewBox.x + (viewBox.width || 1000);

  // Position bubble: if marginRight is set, position in the margin area (outside chart)
  const rectX =
    position === 'right'
      ? chartEndX + marginRight - dynamicWidth - 8 // In margin area
      : 0;
  const textX = rectX + dynamicWidth / 2;

  // Calculate line position - from chart area to the bubble
  const lineStartX = position === 'right' ? 0 : rectX + dynamicWidth + 8;
  const lineEndX = position === 'right' ? rectX - 8 : chartEndX;

  return (
    <g>
      {/* Label bubble */}
      <rect
        x={rectX}
        y={viewBox.y - 10}
        width={dynamicWidth}
        height={20}
        rx={10}
        ry={10}
        fill="hsl(var(--dark-container))"
        stroke="hsl(var(--custom-grey))"
        strokeWidth={0.5}
      />
      <text
        x={textX}
        y={viewBox.y + 3}
        textAnchor="middle"
        fill="hsl(var(--custom-grey))"
        fontSize={9}
        fontWeight={500}
      >
        {label}
      </text>

      {/* Solid horizontal line */}
      <line
        x1={lineStartX}
        y1={viewBox.y}
        x2={lineEndX}
        y2={viewBox.y}
        stroke="hsl(var(--custom-grey))"
        strokeWidth={0.5}
      />
    </g>
  );
};
